import React, { useState } from 'react'
import { Input } from '@/components/common/inputs'
import { SinglePanel } from '@/components/common/panel'
import { useGlobalContext } from '@/components/context'
import style from './index.module.sass'

type Qz = {
	Quarterzip: {
		open: (args: {
			workspaceToken: string
			agentId: string
			user: {
				email: string
				displayName: string
				id: string
			}
		}) => void
		close: () => void
	}
}

export const Qz = () => {
	const globalContext = useGlobalContext()
	const [workspaceToken, setWorkspaceToken] = useState('01fknd7inDdfgnW')
	const [agentKey, setAgentKey] = useState('n9v1h9')

	const doJoin = () => {
		const data: Parameters<Qz['Quarterzip']['open']>[0] = {
			workspaceToken: workspaceToken,
			agentId: agentKey,
			user: {
				email: globalContext.user?.email,
				displayName: globalContext.user?.firstName + ' ' + globalContext.user?.lastName,
				id: globalContext.user?.id,
			}
		}
		console.log('data', data)
		;(window as any as Qz).Quarterzip.open(data)
	}
	const doClose = () => {
		;(window as any as Qz).Quarterzip.close()
	}
	return (
		<SinglePanel type="thin">
			<div className={style.container}>
				<h1>QZ</h1>
				<label>Workspace Key</label>
				<Input
					onChange={(e) => setWorkspaceToken(e.target.value)}
					value={workspaceToken}
					placeholder="Workspace Key"
					autoFocus
				/>
				<label>Agent Key</label>
				<Input onChange={(e) => setAgentKey(e.target.value)} value={agentKey} placeholder="Agent Key" />
				<br/>
				<button onClick={doJoin}>Join Call</button>
				<button onClick={doClose}>Close</button>
			</div>
		</SinglePanel>
	)
}
